export const EditedPart = {
  REASON: 'the reason',
  COMMENT: 'the comment',
  REASON_AND_COMMENT: 'the reason and comment',
};
